import React, { Component } from 'react';
import StatusError from '@/components/status-error';
import { selfJsagentReport } from '@/log';

export default class ErrorBoundary extends Component<any, { hasError: any }> {
  constructor(props: any) {
    super(props);

    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError(error: any) {
    console.error(error);
    selfJsagentReport('js_exec_error', { message: error.message, stack: error.stack });
    return {
      hasError: true,
    };
  }

  render() {
    if (this.state.hasError) return <StatusError />;
    return this.props.children;
  }
}
